import React, { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FooterWrapper,
  FooterContent,
  FooterSection,
  FooterLink,
  FooterBottom,
  LegalLinks,
  SocialMedia,
  SocialLink,
  BrandBlock,
  BrandRow,
  BrandMark,
  BrandName,
  BrandLetter,
  BrandTagline,
  ContactItem,
} from "./Footer.styles";

import { FaInstagram, FaPhone, FaEnvelope } from "react-icons/fa";

import { ReactComponent as Logo } from "../../assets/icons/logoMrc.svg";

const NAV_LINKS = [
  { label: "Prodavnica", to: "/prodavnica?page=1" },
  { label: "Bendovi", to: "/bendovi?page=1" },
  { label: "Novosti", to: "/novosti?page=1" },
  { label: "O nama", to: "/o-nama" },
];

const LEGAL_LINKS = [
  { label: "Uslovi kupovine", to: "/uslovi-kupovine" },
  { label: "Politika privatnosti", to: "/politika-privatnosti" },
  { label: "Reklamacije", to: "/reklamacije" },
];

const Footer = () => {
  const navigate = useNavigate();

  // Logo spin, kao u headeru: pokreće se na hover, ali se uvek odvrti do kraja
  const [logoSpin, setLogoSpin] = useState(false);
  const logoSpinTimer = useRef(null);
  const triggerLogoSpin = useCallback(() => {
    setLogoSpin(true);
    clearTimeout(logoSpinTimer.current);
    // Reset tek kad se animacija (0.7s) završi, spin se uvek odvrti ceo
    logoSpinTimer.current = setTimeout(() => setLogoSpin(false), 760);
  }, []);

  const goTo = (to) => {
    navigate(to);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };

  return (
    <FooterWrapper>
      <div className="container">
        <FooterContent>
          <FooterSection>
            <BrandBlock>
              <BrandRow
                onClick={() => goTo("/")}
                onMouseEnter={triggerLogoSpin}
                aria-label="МРЧ, početna"
              >
                <BrandMark aria-hidden="true">
                  <Logo className={logoSpin ? "spin" : undefined} />
                </BrandMark>
                <BrandName aria-hidden="true">
                  {["М", "Р", "Ч"].map((letter, i) => (
                    <BrandLetter key={letter} style={{ "--i": i }}>
                      <span>{letter}</span>
                    </BrandLetter>
                  ))}
                </BrandName>
              </BrandRow>
              <BrandTagline>
                Zvaničan merch domaće scene. Deo svake kupovine ide direktno
                bendu.
              </BrandTagline>
            </BrandBlock>
          </FooterSection>

          <FooterSection>
            <h3>Navigacija</h3>
            <ul>
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <FooterLink onClick={() => goTo(link.to)}>
                    {link.label}
                  </FooterLink>
                </li>
              ))}
            </ul>
          </FooterSection>

          <FooterSection>
            <h3>Kontakt</h3>
            {/* <ContactItem>
              <FaPhone />
              <span>+381 34 123 4567</span>
            </ContactItem> */}
            <ContactItem>
              <FaEnvelope />
              <span>info@mrc.rs</span>
            </ContactItem>
          </FooterSection>

          <FooterSection>
            <h3>Pratite nas</h3>
            <SocialMedia>
              <SocialLink
                title="@mrc.srbija"
                aria-label="Instagram"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    "https://www.instagram.com/mrc.srbija/",
                    "_blank",
                    "noopener,noreferrer",
                  );
                }}
              >
                <FaInstagram />
              </SocialLink>
            </SocialMedia>
          </FooterSection>
        </FooterContent>

        <FooterBottom>
          <p>© {new Date().getFullYear()} МРЧ. Sva prava zadržana.</p>
          <LegalLinks>
            {LEGAL_LINKS.map((link) => (
              <span key={link.to} onClick={() => goTo(link.to)}>
                {link.label}
              </span>
            ))}
          </LegalLinks>
        </FooterBottom>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
